import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import SelectList from "app/Components/Shared/SelectList/SelectList";
import BtnSubmit from "app/Components/Shared/Buttons/BtnSubmit";
import {
  checkServiceAndGetSubscribers, setError, setSelectedSubscriber, StepsEnum, setStep, init, saveToHistory
} from "app/Components/Block/CellularDataOnOff/CellularDataOnOffSlice";

const SelectSubscriber = (props) => {
  const {
    step,
    error,
    subscriberList,
    selectedSubscriber,
  } = props.cellularDataOnOffSlice;
  const {setStep, setError, setSelectedSubscriber} = props;

  const handleSelectSubscriber = (e) => {
    setSelectedSubscriber(e);
  }

  const onSubmit = async () => {
    setError(null)
    if (!selectedSubscriber) {
      setError("עליך לבחור מנוי כדי להמשיך")
    } else {
      setStep(StepsEnum.TOGGLE_STEP)
    }
  }


  return (
    <div className={'select-subscriber-container'}>
      <div className={'title-container'}>
        <span className={'title'}>
          לאיזה מנוי לשנות סטטוס גלישה?
        </span>
      </div>
      <SelectList
        options={subscriberList}
        onClick={(e) => handleSelectSubscriber(e)}
        hideRadioButtons={true}
      />
      <div className={'bottom-container'}>
        <span className={'error'}>{error}</span>
        <BtnSubmit text={'המשך'} onclick={onSubmit}/>
      </div>
    </div>

  );
};

const mapStateToProps = (state) => {
  return {
    cellularDataOnOffSlice: state.cellularDataOnOffSlice,
  };
};

const mapDispatchToProps = {
  setSelectedSubscriber,
  checkServiceAndGetSubscribers,
  setError,
  setStep,
  init,
  saveToHistory
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectSubscriber);
